import { create } from 'zustand'
import type { MatriculaDetalhes } from '@/types'
import * as alunosApi from '@/api/alunos'
import type { DadosEditaveisDaMatricula } from '@/api/alunos'
import * as parceirosApi from '@/api/parceiros'
import * as matriculasApi from '@/api/matriculas'
import * as usuariosApi from '@/api/usuarios'

interface DetalhesState {
  matricula: MatriculaDetalhes | null
  loading: boolean
  error: string | null
  fetchDetalhes: (matriculaId: number) => Promise<void>
  updateAluno: (cpf: string, dados: DadosEditaveisDaMatricula) => Promise<void>
  reemitirCobranca: (matriculaId: number) => Promise<void>
  definirPermissaoCertificado: (matriculaId: number, permite: boolean) => Promise<void>
  gerarTokenSenha: (usuarioId: number) => Promise<string>
}

export const useDetalhesStore = create<DetalhesState>((set) => ({
  matricula: null,
  loading: false,
  error: null,

  fetchDetalhes: async (matriculaId) => {
    set({ loading: true, error: null })
    try {
      const matricula = await parceirosApi.getAluno(matriculaId)
      set({ matricula })
    } catch {
      set({ error: 'Erro ao carregar matrícula. Verifique sua conexão e tente novamente.' })
    } finally {
      set({ loading: false })
    }
  },

  updateAluno: async (cpf, dados) => {
    await alunosApi.updateAlunoDaMatricula(cpf, dados)
  },

  reemitirCobranca: async (matriculaId) => {
    await matriculasApi.reemitirCobranca(matriculaId)
  },

  definirPermissaoCertificado: async (matriculaId, permite) => {
    await matriculasApi.definirPermissaoCertificado(matriculaId, permite)
  },

  gerarTokenSenha: async (usuarioId) => {
    return usuariosApi.criaTokenMudancaSenha(usuarioId)
  },
}))
